import classNames from 'classnames';
import React from 'react';

import * as styles from './marquee.module.css';
import { MarqueeHeader } from './marquee-header';
import { MarqueeItem } from './marquee-item';

interface MarqueeItemType {
	_key: string;
	brandIcon?: string;
	image?: {
		asset: {
			_ref: string;
			url: string;
		};
	};
	itemDescription?: string;
	itemTitle?: string;
	itemType?: string;
	link?: string;
	svg?: string;
	systemIcon?: string;
}

interface MarqueeData {
	displayText?: string;
	headerText?: string;
	useDynamicContent?: boolean;
	marqueeItems?: MarqueeItemType[];
	itemWidth?: string;
	itemMaxWidth?: string;
}

interface MarqueeProps {
	backgroundColor?: string;
	dynamicContent?: string;
	fadeEffects?: {
		enableFadeEffect?: boolean;
		fadeEffectType?: string;
		fadeEffectDirection?: string;
	};
	headerTextOverride?: string;
	marquee?: MarqueeData;
	stackItems?: boolean;
	textColor?: string;
	useDynamicContent?: boolean;
	verticalPadding?: {
		modulePaddingTop?: string;
		modulePaddingBottom?: string;
	};
}

export function Marquee({
	backgroundColor,
	dynamicContent,
	fadeEffects,
	headerTextOverride,
	useDynamicContent,
	marquee,
	stackItems,
	textColor,
	verticalPadding,
}: MarqueeProps) {
	const { displayText, headerText, marqueeItems, itemWidth, itemMaxWidth } =
		marquee ?? {};

	// content padding
	const modulePaddingTop = verticalPadding?.modulePaddingTop;
	const modulePaddingBottom = verticalPadding?.modulePaddingBottom;

	// fade effects
	const enableFadeEffect = fadeEffects?.enableFadeEffect;
	const fadeEffectType = fadeEffects?.fadeEffectType;
	const fadeEffectDirection = fadeEffects?.fadeEffectDirection;

	return (
		<div
			className={classNames(
				backgroundColor && `b${backgroundColor}`,
				modulePaddingBottom,
				modulePaddingTop,
				styles.moduleContainer
			)}
		>
			<div
				className={classNames(
					'content-container',
					stackItems && styles.stackItems,
					styles.contentContainer,
					textColor
				)}
			>
				{ headerText || headerTextOverride &&
				<MarqueeHeader
					dynamicContent={dynamicContent}
					headerText={headerText}
					headerTextOverride={headerTextOverride}
					useDynamicContent={useDynamicContent}
				/>
			}
				<div
					className={classNames(
						fadeEffectType && fadeEffectType,
						styles.itemsContainer
					)}
				>
					{marqueeItems?.map((marqueeItem) => {
						const {
							_key,
							brandIcon,
							image,
							itemDescription,
							itemTitle,
							itemType,
							link,
							svg,
							systemIcon,
						} = marqueeItem;

						return (
							<div
								className={classNames(
									enableFadeEffect && 'reveal',
									fadeEffectDirection && fadeEffectDirection,
									itemWidth && styles[itemWidth],
									styles.itemContainer
								)}
								key={_key}
								style={
									itemMaxWidth
										? { maxWidth: itemMaxWidth }
										: {}
								}
							>
								{link ? (
									<a
										href={link}
										rel='noopener noreferrer'
										target='_blank'
									>
										{MarqueeItem({
											_key,
											brandIcon,
											displayText,
											image,
											itemDescription,
											itemTitle,
											itemType,
											svg,
											systemIcon,
										})}
									</a>
								) : (
									MarqueeItem({
										_key,
										brandIcon,
										displayText,
										image,
										itemDescription,
										itemTitle,
										itemType,
										svg,
										systemIcon,
									})
								)}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}
